export default function WhySection() {
  const rows = [
    { feature: 'Product Discovery', traditional: 'Slow manual search', vigorbuy: 'Organized database' },
    { feature: 'Product Categories', traditional: 'Scattered information', vigorbuy: 'Structured collections' },
    { feature: 'Comparison', traditional: 'Difficult', vigorbuy: 'Easy comparison' },
    { feature: 'Shopping Research', traditional: 'Time consuming', vigorbuy: 'Simplified workflow' },
    { feature: 'Quality Verification', traditional: 'Unreliable sources', vigorbuy: 'QC photo references' },
    { feature: 'Updates', traditional: 'Outdated listings', vigorbuy: 'Regularly refreshed' },
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
            Why Choose Us
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4 text-balance">
            Why Thousands Search For Vigorbuy Spreadsheet
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            See how <strong>vigorbuy spreadsheet links</strong> and organized product resources transform the way you discover and compare products online.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-50">
                <th className="text-left px-6 py-4 font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                <th className="text-left px-6 py-4 font-semibold text-foreground-500 whitespace-nowrap">
                  <span className="flex items-center gap-2">
                    <i className="ri-search-line text-foreground-400"></i> Traditional Search
                  </span>
                </th>
                <th className="text-left px-6 py-4 font-semibold text-primary-700 whitespace-nowrap">
                  <span className="flex items-center gap-2">
                    <i className="ri-file-list-3-line"></i> Vigorbuy Spreadsheet
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.feature} className={`border-t border-background-200/60 ${i % 2 === 0 ? 'bg-background-50' : 'bg-white'}`}>
                  <td className="px-6 py-3.5 font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                  <td className="px-6 py-3.5 text-foreground-500">{row.traditional}</td>
                  <td className="px-6 py-3.5 text-foreground-800">
                    <span className="flex items-center gap-2">
                      <i className="ri-check-line text-accent-500 text-base"></i> {row.vigorbuy}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}